module.exports = __webpack_public_path__ + "logomark11.png?dca2290ed90fba8f1d416fe42b52ce06";